import {GameRoundPresentation} from "@nolimitcity/slot-game/bin/timelinegameround/core/gameround/GameRoundPresentation";
import {Timeline, TimelineLite} from "gsap";
import {WinterHoardParsedGameData} from "../../server/data/IWinterHoardServerData";
import {IBetLineWinData} from "@nolimitcity/slot-game/bin/core/server/data/IServerData";
import {WinterHoardReelSymbol} from "../../symbols/WinterHoardReelSymbol";
import {Reels} from "@nolimitcity/slot-game/bin/core/reel/reelarea/Reels";
import {WinterHoardGameModuleConfig} from "../../WinterHoardGameModuleConfig";
import {GameRoundManager} from "@nolimitcity/slot-game/bin/timelinegameround/core/gameround/GameRoundManager";


export class BufffaloSymbolWinTease implements GameRoundPresentation {

    private _tl: Timeline;
    private _gameData: WinterHoardParsedGameData;
    private _betLineWinData: IBetLineWinData[];
    private _setupDoneAndRun:boolean = false;
    private _reelId:number;
    private _hasWin:boolean = false;

    private _teasePositions: boolean [][] = [
        [false,false,false,false],
        [false,false,false,false],
        [false,false,false,false],
        [false,false,false,false],
        [false,false,false,false]
    ];

    private _allTeases: boolean [][][] = [];

    private _onReelPositions: boolean [] = [false, false, false, false, false];

    constructor(reelId:number) {
        this._reelId = reelId;
    }

    getAnimation(data: WinterHoardParsedGameData): Timeline {
        const tl:TimelineLite = new TimelineLite();


        // figure out if to run tease
        this._setupDoneAndRun = this.shallRunTease();

        //console.log("TEASE POSITIONS, reelID: " + this._reelId);
        //console.log(this._teasePositions);

        //console.log("LEVEL:" + WinterHoardGameModuleConfig.symbolData.level);

        if(this._setupDoneAndRun && WinterHoardGameModuleConfig.symbolData.level === 5) {
            this._hasWin = true;

            this._teasePositions.forEach((boolArr, rid) => {
                boolArr.forEach((bool, sid) => {
                    if(bool) {
                        tl.add( () => {
                            const symbol:WinterHoardReelSymbol | null = <WinterHoardReelSymbol> Reels.getSymbol(rid, sid);
                            if(symbol) {
                                symbol.playM1Tease();
                            }
                        }, "+=0.1");
                    }
                });
            });

        }

        this._tl = tl;
        return tl;
    }

    private shallRunTease():boolean {
        let bool:boolean = false;

        /**
         0:
         amount: 2
         betLine: (5) [3, 3, 0, 3, 3]
         betLineIndex: 20
         extraMultiplier: 0
         multipliedAmount: 2
         multiplier: 1
         nrOfSymbols: 3
         symbol: "M1"
         */
        // Athi presentation only run tease on first 3 reels
        this._betLineWinData.forEach((lineWin) => {
            if(lineWin.amount > 0 && lineWin.symbol === "M1") {

                if(this._reelId === 2) {
                    this._teasePositions[0][lineWin.betLine[0]] = true;
                    this._teasePositions[1][lineWin.betLine[1]] = true;
                    this._teasePositions[2][lineWin.betLine[2]] = true;
                }
                else if(this._reelId > 2 && lineWin.nrOfSymbols > 3) {
                    if(this._reelId === 3) {
                        this._teasePositions[3][lineWin.betLine[3]] = true;
                    }
                    if(this._reelId === 4 && lineWin.nrOfSymbols > 4) {
                        this._teasePositions[4][lineWin.betLine[4]] = true;
                    }
                }

                bool = true;

                //this._allTeases.push(teasePositions);
            }
        });

        return bool;
    }

    prepare(data: WinterHoardParsedGameData): void {
        this._hasWin = false;
        this._teasePositions = [
            [false,false,false,false],
            [false,false,false,false],
            [false,false,false,false],
            [false,false,false,false],
            [false,false,false,false]
        ];

        this._allTeases = [];

        this._onReelPositions = [false,false,false,false,false];

        this._gameData = data;

        this._betLineWinData = <IBetLineWinData[]> data.betWins!;

    }

    public abort(isActive:boolean, data:WinterHoardParsedGameData):Timeline | null {
        if(isActive && this._tl) {
            GameRoundManager.detachAndPlayTimeline(this._tl);
        }
        else {
            if(this._hasWin) {
                this.getAnimation(data);
            }
        }
        return null;
    }

}